import { render, staticRenderFns } from "./SharedLoginRedirect.vue?vue&type=template&id=511fe534&scoped=true"
import script from "./SharedLoginRedirect.vue?vue&type=script&lang=js"
export * from "./SharedLoginRedirect.vue?vue&type=script&lang=js"
import style0 from "./SharedLoginRedirect.vue?vue&type=style&index=0&id=511fe534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fe534",
  null
  
)

export default component.exports